import * as styles from "./SwiperImage.module.scss";

import cx from "classnames";
import React from "react";
import ProcessedImage from "../common/ProcessedImage/ProcessedImage";
export interface SwiperImageProps {
	// Some images have a 'uri' property
	// Therefore we need to check and use the correct property in each instance
	uri?: string;
	src: string;
	alt: string;
	isDog?: boolean;
	isStandalone?: boolean;
}
export const SwiperImage: React.FC<SwiperImageProps> = ({
	src,
	alt,
	isDog = false,
	isStandalone,
}) => {
	return (
		<div
			className={cx(styles.imagewrapper, {
				[styles.standalone]: isStandalone,
			})}
		>
			<ProcessedImage
				src={src}
				dimensions={"1440x1080"}
				alt={alt}
				isDogImage={isDog}
			/>
		</div>
	);
};

export default SwiperImage;
